import { DatenauswertungReport } from '../datenauswertung/DatenauswertungReport2';
import { getDefaultHelpIcon } from '../../helpers/getDefaultHelpIcon';
import { IDs } from '../../helpers/IDs';
import * as React from 'react';
import { ZusatztoolsExport } from './ZusatztoolsExport';

interface ZusatztoolsReportExportProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
}

interface ZusatztoolsReportExportState {
    jahrFirst: number;
    jahrLast: number;
}

export class ZusatztoolsReportExport extends React.Component<ZusatztoolsReportExportProps, ZusatztoolsReportExportState> {

    constructor(props: any) {
        super(props);
        const startjahr: number = ((this.props.data[IDs.ENT_KONFIGURATION] || [])
            .find((item: any) => item.startjahr_datenerfassung) || {}).startjahr_datenerfassung || null;
        const jahrFirst: number = +startjahr > 1900 ? startjahr : 2010;
        const jahrLast: number = new Date().getFullYear() - 1;
        this.state = {
            jahrFirst,
            jahrLast
        };
    }

    private kennzahlSelected1: string = 'energiekosten_ma';
    private kennzahlSelected2: string = 'energiekosten_umsatz';

    render(): JSX.Element {
        return (
            <div style={{ display: 'flex', flex: 1, flexDirection: 'row' }}>
                <div style={{ width: '50%', display: 'flex', flex: 1, flexDirection: 'column' }}>
                    {getDefaultHelpIcon(
                        'pageReport', 'Hilfe zum Report', this.props.data, {}, {},
                        { margin: '10px 28px -28px 0', right: 'unset', display: 'flex', alignSelf: 'flex-end', position: 'relative' }
                    )}
                    {/* {getDefaultHelpIcon('pageReport', 'Hilfe zum Report', this.props.data, { marginRight: '50%' })} */}
                    <DatenauswertungReport
                        data={this.props.data}
                        jahrFirst={this.state.jahrFirst}
                        jahrLast={this.state.jahrLast}
                        onRoutingChange={this.props.onRoutingChange}
                        routing={this.props.routing}
                    />
                </div>
                <div style={{ borderLeft: '1px solid #aaa', flex: 1 }}>
                    {getDefaultHelpIcon('pageExcelExport', 'Hilfe zum Excel-Export', this.props.data)}
                    <ZusatztoolsExport
                        data={this.props.data}
                    />
                </div>
            </div>
        );
    }
}
